import { Response } from "react-select-async-paginate";
import AsyncPaginateBootstrap from "../react-select-bootstrap/AsyncPaginateBootstrap";
import { getList } from "../../api/generics";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import AssetSubtype from "../../models/asset-subtype";

const RECORS_PER_SEARCH = 20;

type AssetSubtypeSelectProps = {
  value: AssetSubtype | null;
  disabled?: boolean;
  onChange: (_: AssetSubtype | null) => void;
};

const AssetSubtypeSelect: React.FC<AssetSubtypeSelectProps> = ({
  value,
  disabled,
  onChange,
}) => {
  const companyId = useSelector(
    (state: RootState) => state.company.data.company.id
  );
  const loadOptions = async (
    s: string,
    currentOpts: readonly (
      | AssetSubtype
      | { options: AssetSubtype[]; label?: string }
    )[]
  ): Promise<
    Response<AssetSubtype, { options: AssetSubtype[]; label?: string }, any>
  > => {
    let additionalParams: Map<string, string> | undefined = new Map<
      string,
      string
    >();

    additionalParams.set("company_id", companyId!.toString());

    if (s !== "") {
      additionalParams.set("search", s);
    }

    const dataPaginated = await getList<AssetSubtype>(
      "/asset_subtypes/",
      RECORS_PER_SEARCH,
      currentOpts.length,
      additionalParams
    );

    let newOpts: AssetSubtype[] = [];
    let count = 0;

    if (dataPaginated.data !== undefined) {
      newOpts = dataPaginated.data.items;
      count = dataPaginated.data.count;
    }

    const hasMore = currentOpts.length + newOpts.length < count;

    return {
      options: newOpts,
      hasMore: hasMore,
    };
  };
  return (
    <AsyncPaginateBootstrap
      placeholder={"Selecccione Subtipo de activo"}
      onChange={onChange}
      isMulti={false}
      debounceTimeout={300}
      loadOptions={loadOptions}
      getOptionLabel={(option: AssetSubtype) => `${option.name}`}
      getOptionValue={(option: AssetSubtype) => `${option.id}`}
      value={value}
      isDisabled={disabled}
      isClearable={true}
    />
  );
};

export default AssetSubtypeSelect;
